import React from "react";
import { FullWidthDivider } from "./divider";

const Modal = ({
  title,
  description = null,
  subhed = null,
  children,
  style = {},
  modalStyle = {}
}) => {
  return (
    <div style={style}>
      <div className="dashboard-modal" style={modalStyle}>
        <div className="form-block">
          <div className="form-content-bp horizontally-centered">
            <div style={{ margin: "1em" }}>
              <h1>{title}</h1>
              {description !== null && <p dangerouslySetInnerHTML={{ __html: description }}></p>}
              {subhed !== null && (
                <p
                  style={{
                    fontFamily: "BentonModernDisplaySemiBold",
                    fontSize: "10pt",
                    letterSpacing: 1,
                    lineHeight: "12pt",
                    margin: 0
                  }}
                >
                  {subhed}
                </p>
              )}
            </div>
            <FullWidthDivider />
            <div className="input-grid">
              <div className="input-column-bp flexible" style={{ marginBottom: "2em" }}>
                {children}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style={{ height: 1000 }}>&nbsp;</div>
    </div>
  );
};

export default Modal;
